import React, { FC } from 'react'
import { SpriteIcon } from '@components/Sprites/SpriteIcon'
import s from './errorRow.module.scss'

interface Props {
    children: React.ReactNode
}

export const ErrorRow: FC<Props> = ({ children }) => {
    return (
        <div className={s.errorRow}>
            <SpriteIcon name={'info'} width={18} height={18} color={'--Mandarin-Red'} />
            {children}
        </div>
    )
}
